// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2l4XF","dragIcon":"SortableItem_dragIcon__2_SzV","disabled":"SortableItem_disabled__3W-kJ"};